// File Metadata:
// Filename: NewDepartureTU.js
// Version: 1.00
// Created: 2025-03-22 01:37:15
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React, { useState, useEffect } from 'react'
import { Button, TextField, Card, CardHeader, CardContent, Alert, List, ListItem, ListItemText, ListItemButton, Collapse, Typography } from '@mui/material'
import { useGetPendingDeparturesQuery } from '../../api/crossdockApiSlice'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'

const NewDepartureTU = ({ nextStep, handleValue, values }) => {
    const [selectedTour, setSelectedTour] = useState('')
    const [errMsg, setErrMsg] = useState('')
    const [openTour, setOpenTour] = useState(null)
    
    const { data: pendingDepartures, error, isLoading } = useGetPendingDeparturesQuery()

    console.log('Pending Departures Response:', { data: pendingDepartures, error, isLoading })

    const hasData = pendingDepartures?.pendingDepartures && 
                   Object.keys(pendingDepartures.pendingDepartures).length > 0

    const handleTourSelect = (tour, hus) => {
        setSelectedTour(tour)
        handleValue('departureTour', tour)
        handleValue('pendingHUs', hus.flatMap(h => h.handlingUnits.map(hu => ({
            ...hu,
            crossdockId: h.crossdockId,
            location: h.location
        }))))
        nextStep()
    }

    const handleTourClick = (tour) => {
        setOpenTour(openTour === tour ? null : tour)
    }

    if (isLoading) return <Typography>Loading...</Typography>
    
    return (
        <Card sx={{ width: 345, minWidth: 200, boxShadow: 2, margin: 2 }}>
            <CardHeader title='Select Departure Tour' />
            <CardContent>
                {errMsg && <Alert severity='error'>{errMsg}</Alert>}
                {error && 
                    <Alert severity={error.status === 404 ? "info" : "error"}>
                        {error?.data?.message || 'Error loading departures'}
                    </Alert>
                }
                {hasData && (
                    <List>
                        {Object.entries(pendingDepartures.pendingDepartures).map(([tour, hus]) => (
                            <React.Fragment key={tour}>
                                <ListItemButton onClick={() => handleTourClick(tour)}>
                                    <ListItemText 
                                        primary={`Tour: ${tour}`}
                                        secondary={`${hus.reduce((acc, h) => acc + h.handlingUnits.length, 0)} HUs`}
                                    />
                                    {openTour === tour ? <ExpandLess /> : <ExpandMore />}
                                </ListItemButton>
                                <Collapse in={openTour === tour} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {hus.flatMap(h => h.handlingUnits).map((hu, index) => (
                                            <ListItem key={index} sx={{ pl: 4 }}>
                                                <ListItemText 
                                                    primary={hu.sscc}
                                                    secondary={`Type: ${hu.packageType}`}
                                                />
                                            </ListItem>
                                        ))}
                                        <ListItem sx={{ pl: 4 }}>
                                            <Button 
                                                fullWidth
                                                variant="contained"
                                                onClick={() => handleTourSelect(tour, hus)}
                                            >
                                                Select Tour
                                            </Button>
                                        </ListItem>
                                    </List>
                                </Collapse>
                            </React.Fragment>
                        ))}
                    </List>
                )}
            </CardContent>
        </Card>
    )
}

export default NewDepartureTU
